import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { LayerState } from "react-atmosphere";

const TRANSITION_DURATION = 150;

export function AnimatedPopout({
  state,
  completeTransitionExit,
  transformOrigin,
  children,
}: {
  state: LayerState;
  completeTransitionExit: () => void;
  transformOrigin:
    | "top center"
    | "top left"
    | "top right"
    | "bottom center"
    | "center left"
    | "center right";
  children: React.ReactNode;
}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    if (state === LayerState.TransitionExit) {
      setShow(false);
      setTimeout(() => {
        completeTransitionExit();
      }, TRANSITION_DURATION);
    }
  }, [state]);
  return (
    <div
      className={classNames(
        "transition transform",
        show ? "opacity-100 scale-100" : "opacity-0 scale-90"
      )}
      style={{ transformOrigin }}
    >
      {children}
    </div>
  );
}
